import React from 'react';
import { WifiIcon, SignalIcon, SignalSlashIcon } from '@heroicons/react/24/outline';

interface ConnectionStatusProps {
  state: string;
}

/**
 * Connection status indicator for video sessions
 * Shows connection quality and state
 */
export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ state }) => {
  const getStatusInfo = (state: string) => {
    switch (state) {
      case 'joined-meeting':
        return {
          label: 'Connected',
          color: 'bg-green-600',
          icon: <SignalIcon className="w-4 h-4" />,
        };
      case 'joining-meeting':
        return {
          label: 'Connecting...',
          color: 'bg-yellow-600',
          icon: <WifiIcon className="w-4 h-4 animate-pulse" />,
        };
      case 'error':
      case 'left-meeting':
        return {
          label: 'Disconnected',
          color: 'bg-red-600',
          icon: <SignalSlashIcon className="w-4 h-4" />,
        };
      default:
        return {
          label: 'Loading...',
          color: 'bg-gray-600',
          icon: <WifiIcon className="w-4 h-4" />,
        };
    }
  };

  const status = getStatusInfo(state);

  return (
    <div className="absolute top-4 left-4 z-10">
      <div className={`flex items-center space-x-2 px-3 py-2 rounded-lg ${status.color} text-white shadow-lg`}>
        {status.icon}
        <span className="text-sm font-medium">{status.label}</span>
      </div>
    </div>
  );
};
